<template>
  <loan-list
    filter=""
    :title="$t('label.unknownLoanType')"
  />
</template>

<script>
import LoanList from './List'
export default {
  name: 'UnknownLoanTypeList',
  components: { LoanList }
}
</script>

<style scoped>

</style>
